import type { Job } from '@/mocks/jobs';

export interface JobDbRow {
  id: string;
  title: string;
  company: string | null;
  category: string | null;
  contract_type: string | null;
  salary_min: number | null;
  salary_max: number | null;
  city: string | null;
  description: string | null;
  requirements: string | null;
  contact_email: string | null;
  contact_phone: string | null;
  created_at: string | null;
}

export function mapDbJob(row: JobDbRow): Job {
  return {
    id: row.id,
    title: row.title,
    company: row.company || 'Entreprise',
    category: row.category || 'Autre',
    contractType: row.contract_type || 'CDI',
    salaryMin: Number(row.salary_min) || null,
    salaryMax: Number(row.salary_max) || null,
    city: row.city || 'Lomé',
    description: row.description || '',
    requirements: row.requirements || '',
    contactEmail: row.contact_email || '',
    contactPhone: row.contact_phone || '',
    postedAt: row.created_at ? row.created_at.slice(0, 10) : '',
  };
}

export function formatSalary(job: { salaryMin: number | null; salaryMax: number | null }): string {
  if (!job.salaryMin && !job.salaryMax) return 'Selon profil';
  const fmt = (n: number) => `${n.toLocaleString('fr-FR')} FCFA`;
  if (job.salaryMin && job.salaryMax) return `${fmt(job.salaryMin)} - ${fmt(job.salaryMax)}`;
  if (job.salaryMin) return `À partir de ${fmt(job.salaryMin)}`;
  return `Jusqu'à ${fmt(job.salaryMax!)}`;
}